import { PL } from '../../../../constants/accessToPages';
import { generatePatientInfoRouterConfig } from '../../../root/router/sharedConfigs';

import Patients from './Patients';

export const patientsRouterConfig = {
  name: 'Patients',
  path: '/patients',
  component: Patients,
  access: [PL],
  inherited: [...generatePatientInfoRouterConfig(PL, PL)]
};
